// Copyright (c) 2017 Deere & Company

import {getDefaultState} from '../state/grid-api';

export default (state = getDefaultState()) => state;



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/reducers/grid-api.js